import { PropertyRef, defineBool, defineEnum } from '@spotify-internal/remote-config-properties';

/**
 * Define properties here and add them into the following array.
 * More on `docs/RemoteConfig/properties.md`
 */
export const ubiTestBool = defineBool({
  name: 'ubiTest',
  description: 'A/A-test to confirm integration towards UBI',
  default: false,
});

// HackWeek 27 - 31 March 2023
// Second Experiment (4th May)
// The control will show the survey option (ReasonSelector component)
// The target will omit that step.
export enum FeedbackStatus {
  SHOW_SURVEY = 'SHOW_SURVEY',
  DO_NOT_SHOW_SURVEY = 'DO_NOT_SHOW_SURVEY',
  ORIGINAL = 'ORIGINAL',
}

export const showSurveyOptionEnum = defineEnum({
  name: 'showSurveyOption',
  description: 'A/B-test to improve the UX in the FeedbackWidget',
  values: FeedbackStatus,
  default: FeedbackStatus.ORIGINAL,
});

export const usePillowTalk = defineBool({
  name: 'usePillowTalk',
  description: 'Boolean to control wether or not to use pillow talk',
  default: false,
});

export const useSemanticSearch = defineBool({
  name: 'useSemanticSearch',
  description: 'Wether or not to use semantic search',
  default: false,
});

export const properties: Array<PropertyRef> = [ubiTestBool, showSurveyOptionEnum, usePillowTalk, useSemanticSearch];

export type PropertyTypes = (typeof properties)[number]['_type'];
